import AttachmentFile, { AttachmentFileList, AttachmentFileType } from './types/AttachmentFile';
import AttachmentFileAttributes from './types/AttachmentFileAttributes';
import AttachmentItemFile, { AttachmentItemFileList } from './types/AttachmentItemFile';
import Base64InlineImageFile from './types/Base64InlineImageFile';
import CloudFile, { CloudFileList } from './types/CloudFile';
import convertToAttachmentDataProviderType from './utils/convertToAttachmentDataProviderType';
import createAttachmentItemFileFromDataProviderItem from './utils/createAttachmentItemFileFromDataProviderItem';
import createCloudFileFromDataProviderItem from './utils/createCloudFileFromDataProviderItem';
import createLocalComputerFiles from './utils/createLocalComputerFiles';
import createMailItemFiles from './utils/createMailItemFiles';
import createUriFiles from './utils/createUriFiles';
import LocalComputerFile, { LocalComputerFileList } from './types/LocalComputerFile';
import MailItemFile, { MailItemFileList } from './types/MailItemFile';
import UriFile, { UriFileList } from './types/UriFile';

export {
    convertToAttachmentDataProviderType,
    createLocalComputerFiles,
    createMailItemFiles,
    createAttachmentItemFileFromDataProviderItem,
    createCloudFileFromDataProviderItem,
    createUriFiles,
};

// Types
export { AttachmentFile };
export { AttachmentFileAttributes };
export { AttachmentFileList };
export { AttachmentFileType };
export { AttachmentItemFile };
export { AttachmentItemFileList };
export { Base64InlineImageFile };
export { CloudFile };
export { CloudFileList };
export { LocalComputerFile };
export { LocalComputerFileList };
export { MailItemFile };
export { MailItemFileList };
export { UriFile };
export { UriFileList };
